export enum PlanningMenuAction {
  GENERATOR = 'GENERATOR',
  COMMENTS = 'COMMENTS',
  PRINT = 'PRINT',
  ADD_PRESTATION = 'ADD_PRESTATION',
  COPY = 'COPY',
  CUT = 'CUT',
  PASTE = 'PASTE',
  SWITCH = 'SWITCH',
  EMPLOYEES_SUMMARY = 'EMPLOYEES_SUMMARY',
  SNAPSHOT = 'SNAPSHOT',
  EXPORT = 'EXPORT',
  IMPORT = 'IMPORT',
  BATCH_DELETION = 'BATCH_DELETION',
  FILTER = 'FILTER',
  SECTION_PRESTATIONS = 'SECTION_PRESTATIONS',
  BATCH_LOCK = 'BATCH_LOCK',
  RUN_CONTROLS = 'RUN_CONTROLS',
  TRANSFER = 'TRANSFER',
  SEARCH = 'SEARCH',
  HISTORY = 'HISTORY'
}
